import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {compose} from 'redux';
import * as Yup from 'yup';
import {ITenant} from '../../../../App';
import AppErrorMessage from '../../../../components/app-error-message';
import {
  AppForm,
  AppFormCheckboxField,
  AppFormDatePickerField,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../components/forms';
import Header2 from '../../../../components/headers/header2';
import {Column, Row} from '../../../../components/layout';
import * as fonts from '../../../../util/fonts';
import {strings} from '../../../../util/strings';
import {has18Years, today} from '../../../../util/utility';
import './styles.scss';

interface InsuranceValidationProps {
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  nextStep(): void;
  valid: boolean;
  labels: typeof strings.pt.register;
  labelsLogin: typeof strings.pt.login;
  oneTrust: typeof strings.pt.oneTrust;
  messageLabels: typeof strings.pt.messages;
  globalStyles: any;
  tenant: ITenant;
}

function InsuranceValidation({
  onSubmit,
  valid,
  setValid,
  nextStep,
  labels,
  labelsLogin,
  oneTrust,
  messageLabels,
  globalStyles,
  tenant,
}: InsuranceValidationProps) {
  const [formikContext, setFormikContext] = useState();
  const [hoverErrorIcons, setHoverErrorIcons] = useState<any>({
    name: false,
    nif: false,
    dateOfBirth: false,
  });

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required(messageLabels?.requiredField)
      .matches(
        new RegExp('^(?![\\s\\S]{51,})([^0-9\\s]+\\s[^0-9\\s]{1,30})$'),
        labels?.register_nameValidationError
      ),
    nif: Yup.string()
      .required(messageLabels?.requiredField)
      .matches(
        new RegExp(tenant?.vatNumberValidator),
        messageLabels?.invalidFormat
      ),
    dateOfBirth: Yup.date()
      .required(messageLabels?.requiredField)
      .nullable()
      .max(today(), messageLabels?.invalidDate),
    acceptedTermsAndConditions: Yup.boolean().required().oneOf([true]),
    acceptedDataTreatment: Yup.boolean().required().oneOf([true]),
  });

  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string,
    dateInput?: boolean
  ) => {
    var elem: HTMLElement = e.target as HTMLElement;
    if (!dateInput) {
      var icon: HTMLElement = elem.nextSibling as HTMLElement;
      defineIconFunctions(icon, fieldNamePar);
    }

    if (
      dateInput &&
      elem.tagName.includes('svg') &&
      elem.className['baseVal' as any].includes('error')
    ) {
      var icon: HTMLElement = elem as HTMLElement;
      defineIconFunctions(icon, fieldNamePar);
    }
  };

  const defineIconFunctions = (icon: HTMLElement, fieldNamePar: any) => {
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: true});
      };
      // icon.onmouseout = function () {
      //   setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: false});
      // };
    }
  };

  useEffect(() => {
    if (formikContext) {
      (formikContext as any)?.validateForm((formikContext as any)?.values);
    }
  }, [formikContext]);

  const history = useHistory();

  return (
    <Column className="insurance-validation-container">
      <Header2 className="insurance-validation-step-titile">
        {/* {labels?.register_step1} */}
      </Header2>
      <Header2 style={{...fonts.ML, ...fonts.Regular}}>
        {labels?.register_pageSubTitle}
      </Header2>
      <AppForm
        className="insurance-validation-form-container"
        initialValues={{
          name: '',
          nif: '',
          dateOfBirth: null,
          acceptedTermsAndConditions: false,
          acceptedDataTreatment: false,
        }}
        validationSchema={validationSchema}
        onValidation={(valid) => setValid(valid)}
        onSubmit={(values) => {
          if (has18Years(values.dateOfBirth)) {
            onSubmit(values);
            nextStep();
          } else {
            history.push('/utilizador-menor');
          }
        }}>
        <Row className="mb-0" style={{position: 'relative'}}>
          <AppFormField
            name="name"
            placeholder={labels?.register_namePlaceholder}
            handleFormikContext={(formik) => {
              if (
                !!!formikContext ||
                formik.errors !== (formikContext as any).errors
              ) {
                setFormikContext(formik);
              }
            }}
            onMouseOver={(e) => {
              defineOnMouseFunctions(e, 'name');
            }}
            onMouseOut={() => {
              setHoverErrorIcons({...hoverErrorIcons, ['name']: false});
            }}
          />
          {hoverErrorIcons.name && (
            <AppErrorMessage
              message={
                (formikContext &&
                  (formikContext as any).errors &&
                  (formikContext as any).errors.name) ||
                messageLabels?.requiredField
              }
              onMouseOut={() => {
                setHoverErrorIcons({...hoverErrorIcons, ['name']: false});
              }}
              className={
                (formikContext &&
                  (formikContext as any).errors &&
                  (formikContext as any).errors.name) ===
                labels?.register_nameValidationError
                  ? 'insurance-validation-pop-up-error-message-name-match'
                  : 'insurance-validation-pop-up-error-message'
              }
            />
          )}
        </Row>
        <Row className="insurance-validation-nif-row">
          <Column
            className="insurance-validation-nif-column"
            style={{position: 'relative'}}>
            <AppFormField
              name="nif"
              placeholder={labels?.register_nifPlaceholder}
              onMouseOver={(e) => {
                defineOnMouseFunctions(e, 'nif');
              }}
              onMouseOut={() => {
                setHoverErrorIcons({...hoverErrorIcons, ['nif']: false});
              }}
              // guardar o nif para enviar para o Communications
            />
            {hoverErrorIcons.nif && (
              <AppErrorMessage
                message={
                  (formikContext &&
                    (formikContext as any).errors &&
                    (formikContext as any).errors.nif) ||
                  messageLabels?.requiredField
                }
                onMouseOut={() => {
                  setHoverErrorIcons({...hoverErrorIcons, ['nif']: false});
                }}
                className="insurance-validation-pop-up-error-message"
              />
            )}
          </Column>
          <Column
            className="insurance-validation-dob-column"
            style={{position: 'relative'}}
            onMouseOver={(e) => {
              defineOnMouseFunctions(e, 'dateOfBirth', true);
            }}
            onMouseOut={() => {
              setHoverErrorIcons({
                ...hoverErrorIcons,
                ['dateOfBirth']: false,
              });
            }}>
            <AppFormDatePickerField
              name="dateOfBirth"
              placeholder={labels?.register_birthdayPlaceholder}
              maxDate={new Date()}
              handleFormikContext={(formik) => {
                if (
                  !!!formikContext ||
                  formik.errors !== (formikContext as any).errors
                ) {
                  setFormikContext(formik);
                }
              }}
              onMouseOut={() => {
                setHoverErrorIcons({
                  ...hoverErrorIcons,
                  ['dateOfBirth']: false,
                });
              }}
            />
            {hoverErrorIcons.dateOfBirth && (
              <AppErrorMessage
                message={
                  (formikContext &&
                    (formikContext as any).errors &&
                    (formikContext as any).errors.dateOfBirth) ||
                  messageLabels?.requiredField
                }
                className="insurance-validation-pop-up-error-message-dateofbirth"
                onMouseOut={() => {
                  setHoverErrorIcons({
                    ...hoverErrorIcons,
                    ['dateOfBirth']: false,
                  });
                }}
              />
            )}
          </Column>
        </Row>
        <Row>
          <Column className="insurance-validation-checkboxes">
            <AppFormCheckboxField
              purposeId={oneTrust?.purposeTermsAndConditions}
              name="acceptedTermsAndConditions"
              label={
                <label
                  className="align-left-label"
                  style={{textAlign: 'start', ...fonts.SM, ...fonts.Medium}}>
                  {labels?.register_termsAndConditionsInit}{' '}
                  <a
                    className="insurance-validation-anchors"
                    style={{color: globalStyles?.primaryColor}}
                    href={labelsLogin?.login_acceptConditionsUrl}
                    target="_blank">
                    {labels?.register_termsAndConditionsLink}
                  </a>
                </label>
              }
              labelClass="checkboxes-label"
            />
            <AppFormCheckboxField
              purposeId={oneTrust?.purposePolicyDataTreatment}
              name="acceptedDataTreatment"
              label={
                <label
                  className="align-left-label"
                  style={{...fonts.SM, ...fonts.Medium}}>
                  {labels?.register_privacyInit}{' '}
                  <a
                    className="insurance-validation-anchors"
                    style={{color: globalStyles?.primaryColor}}
                    href={labelsLogin?.login_acceptPrivacyPolicyUrl}
                    target="_blank">
                    {labels?.register_privacyLink}
                  </a>
                </label>
              }
              labelClass="checkboxes-label"
            />
          </Column>
        </Row>
        <Row className="insurance-validation-continue-button-row">
          <AppFormSubmitButton
            title={labelsLogin?.login_forgotPassword_continuar}
            disabled={!valid}
            className="stepper-continue-button"
          />
        </Row>
      </AppForm>
    </Column>
  );
}

const mapStateToProps = ({stringsDefault, globalStyles, tenant}: any) => ({
  labels: stringsDefault.value.pt.register,
  labelsLogin: stringsDefault.value.pt.login,
  oneTrust: stringsDefault.value.pt.oneTrust,
  messageLabels: stringsDefault.value.pt.messages,
  globalStyles: globalStyles.value,
  tenant: tenant.value,
});

export default compose(connect(mapStateToProps)(InsuranceValidation));
